<template>
    <div>
        <div
            class="rotate-12 text-center font-accent"
            v-html="arrowCallout.text"
        ></div>
        <img
            v-if="arrowCallout.type === 'down-small'"
            src="/images/content_arrows/down-small-arrow.svg"
            class="absolute bottom-[-55px] right-6"
            alt="down arrow"
            type="svg"
        />
        <img
            v-if="arrowCallout.type === 'down-large'"
            src="/images/content_arrows/down-large-arrow.svg"
            class="absolute bottom-[-40px] left-[-20px]"
            alt="down arrow"
            type="svg"
        />
        <img
            v-if="arrowCallout.type === 'down-curved'"
            src="/images/content_arrows/down-curved-arrow.svg"
            class="absolute bottom-[-48px] right-[-18px]"
            alt="down arrow"
            type="svg"
        />
    </div>
</template>

<script setup lang="ts">
import type { ArrowCalloutType } from '#shared/types/ArrowCalloutType';

defineProps<{
    arrowCallout: ArrowCalloutType;
}>();
</script>
